import { API_ENDPOINT } from '../constans/index'
import { APIS } from './configs/AVAILABLE_APIS'
import { API_PARAMS, getRequestConfig, request, setTokenConf } from './configs/restServiceConfig'
import { IPagination, IUserRead } from './configs/types'

export interface IUserListResponse {
  error?: any
  pagination: IPagination
  result: IUserRead[]
}

export interface IUserRetrieveResponse {
  pagination: IPagination
  result: IUserRead
}

interface ListProps {
  params?: API_PARAMS
  token: string
}

interface PublicRequestProps {
  params?: API_PARAMS
}

class UserService {
  list = async ({ params = {}, token = '' }: ListProps): Promise<IUserListResponse> => {
    const API_OPTIONS_CONFIG = getRequestConfig('LIST', APIS.Users, API_ENDPOINT)
    return await request(API_OPTIONS_CONFIG, setTokenConf(params, token))
  }

  me = async ({ token = '' }: ListProps): Promise<IUserRetrieveResponse> => {
    const API_OPTIONS_CONFIG = getRequestConfig('LIST', APIS.Me, API_ENDPOINT)
    return await request(API_OPTIONS_CONFIG, setTokenConf({}, token))
  }

  retrieve = async ({ params = {}, token = '' }: ListProps): Promise<IUserRetrieveResponse> => {
    const API_OPTIONS_CONFIG = getRequestConfig('RETRIEVE', APIS.Users, API_ENDPOINT)
    return await request(API_OPTIONS_CONFIG, setTokenConf(params, token))
  }

  create = async ({ params = {}, token = '' }: ListProps): Promise<IUserRetrieveResponse> => {
    const API_OPTIONS_CONFIG = getRequestConfig('CREATE', APIS.Users, API_ENDPOINT)
    return await request(API_OPTIONS_CONFIG, setTokenConf(params, token))
  }

  update = async ({ params = {}, token = '' }: ListProps): Promise<IUserRetrieveResponse> => {
    const API_OPTIONS_CONFIG = getRequestConfig('UPDATE', APIS.Users, API_ENDPOINT)
    return await request(API_OPTIONS_CONFIG, setTokenConf(params, token))
  }

  partialUpdate = async ({ params = {}, token = '' }: ListProps): Promise<IUserRetrieveResponse> => {
    const API_OPTIONS_CONFIG = getRequestConfig('PARTIAL_UPDATE', APIS.Users, API_ENDPOINT)
    return await request(API_OPTIONS_CONFIG, setTokenConf(params, token))
  }

  delete = async ({ params = {}, token = '' }: ListProps): Promise<IUserRetrieveResponse> => {
    const API_OPTIONS_CONFIG = getRequestConfig('DELETE', APIS.Users, API_ENDPOINT)
    return await request(API_OPTIONS_CONFIG, setTokenConf(params, token))
  }

  bulkDelete = async ({ params = {}, token = '' }: ListProps): Promise<IUserListResponse> => {
    const API_OPTIONS_CONFIG = getRequestConfig('BULK_DELETE', APIS.Users, API_ENDPOINT)
    return await request(API_OPTIONS_CONFIG, setTokenConf(params, token))
  }

  changeSelfPassword = async ({ params = {}, token = '' }: ListProps): Promise<IUserRetrieveResponse> => {
    const API_OPTIONS_CONFIG = getRequestConfig('CREATE', APIS.AuthPasswordChange, API_ENDPOINT)
    return await request(API_OPTIONS_CONFIG, setTokenConf(params, token))
  }

  resetPassword = async ({ params = {} }: PublicRequestProps): Promise<IUserRetrieveResponse> => {
    const API_OPTIONS_CONFIG = getRequestConfig('CREATE', APIS.AuthPasswordReset, API_ENDPOINT)
    return await request(API_OPTIONS_CONFIG, setTokenConf(params, process.env.NEXT_PUBLIC_API_TOKEN ?? ''))
  }

  resetPasswordConfirm = async ({ params = {} }: PublicRequestProps): Promise<IUserRetrieveResponse> => {
    const API_OPTIONS_CONFIG = getRequestConfig('CREATE', APIS.AuthPasswordResetConfirm, API_ENDPOINT)
    return await request(API_OPTIONS_CONFIG, setTokenConf(params, process.env.NEXT_PUBLIC_API_TOKEN ?? ''))
  }
}

export const userService = new UserService()
